<template>
  <el-dialog
    title="用户信息"
    :visible.sync="dialogVisible"
    width="500px"
    append-to-body
    :before-close="handleClose"
  >
    <el-form ref="formLabelAlign" label-position="right" label-width="140px" :model="formData">
      <el-form-item label="账号：" class="oldPass" prop="oldPass">
        <span>{{ user.username }}</span>
      </el-form-item>
      <el-form-item label="姓名：" class="oldPass" prop="oldPass">
        <span>{{ user.realName }}</span>
      </el-form-item>
      <el-form-item label="手机号：" class="oldPass" prop="oldPass">
        <span>{{ user.phone }}</span>
      </el-form-item>
      <el-form-item label="角色列表：" class="oldPass" prop="oldPass">
        <div v-if="user.roles">
          <el-tag v-for="item in user.roles" :key="item.id" style="margin-right: 5px;">{{item.name}}</el-tag>
        </div>
      </el-form-item>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-form>
  </el-dialog>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: 'UserInfoDialog',
  data() {
    return {
      dialogVisible: false,
      formData: {},
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
  }
}
</script>

<style lang="scss">
::v-deep {
  .el-dialog__body {
    padding: 15px 20px;
  }
}
</style>
